import { Box, Checkbox, Stack, Tooltip, Typography } from "@mui/material";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem.tsx";
import type { TotalPickerRow } from "../utils/statementLineOptions.ts";

interface TotalOfLinesRowProps {
  row: TotalPickerRow;
  readonly: boolean;
  onToggle: (guid: string) => void;
}

const TotalOfLinesRow = ({ row, readonly, onToggle }: TotalOfLinesRowProps) => {
  const disabled = readonly || row.cycleMessage !== undefined;

  return (
    <Tooltip title={row.cycleMessage}>
      <Box>
        <PopoverMenuItem disabled={disabled} onClick={() => onToggle(row.guid)} sx={{ gap: 1, py: 0.25, px: 1.25 }}>
          <Checkbox checked={row.checked} disabled={disabled} tabIndex={-1} sx={{ p: 0.5 }} />
          <Typography noWrap sx={{ flex: 1, minWidth: 0 }}>
            {row.label}
          </Typography>
        </PopoverMenuItem>
      </Box>
    </Tooltip>
  );
};

interface Props {
  rows: TotalPickerRow[];
  note: string;
  readonly: boolean;
  onToggle: (guid: string) => void;
}

const TotalOfLinesPicker = ({ rows, note, readonly, onToggle }: Props) => (
  <Stack sx={{ pb: 1 }}>
    <Typography variant="subtitle1" sx={{ px: 2, py: 1 }}>
      Total of Lines
    </Typography>
    <Stack
      sx={(theme) => ({
        mx: 2,
        maxHeight: 240,
        overflowY: "auto",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
      })}
    >
      {rows.map((row) => (
        <TotalOfLinesRow key={row.guid} row={row} readonly={readonly} onToggle={onToggle} />
      ))}
    </Stack>
    <Typography variant="caption" color="textSecondary" sx={{ px: 2, pt: 1 }}>
      {note}
    </Typography>
  </Stack>
);

export default TotalOfLinesPicker;
